// extracted by mini-css-extract-plugin
module.exports = {"root":"BulkEditing_root__M_qoy","selector":"BulkEditing_selector__WqyFE","button":"BulkEditing_button__1bFKH"};